export default __webpack_public_path__ + "../staticImages/wsh_geschenke_rot-260.png";